import type { BillingCaseRowItem } from "../../types";
import type { SubmittedPendingChange } from "../types";

export const buildSubmittedEumCase = (
  billingCase: BillingCaseRowItem,
  results: SubmittedPendingChange[],
): BillingCaseRowItem | null => {
  const [firstResult] = results;
  if (!firstResult) {
    return null;
  }

  return {
    ...billingCase,
    changeRequestId: firstResult.changeRequestId,
    billingCaseId: firstResult.billingCaseId,
    status: firstResult.status,
  };
};
